import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

import { api } from "../api/client";
import type { BusinessInfo } from "../api/types";
import { BUSINESS } from "./business";

/**
 * Hours, address, phone — the live copy from the server, edited in
 * /dashboard. The bundled copy renders first so nothing waits on the
 * request; the fetched one replaces it a moment later.
 */

const BusinessContext = createContext<BusinessInfo>(BUSINESS);

export function BusinessProvider({ children }: { children: ReactNode }) {
  const [business, setBusiness] = useState<BusinessInfo>(BUSINESS);

  useEffect(() => {
    let alive = true;
    api.business().then((info) => {
      // Documents saved before the day-part times existed lack them: fill from the seed.
      if (alive) setBusiness({ ...info, dayparts: { ...BUSINESS.dayparts, ...(info.dayparts ?? {}) } });
    });
    return () => {
      alive = false;
    };
  }, []);

  return <BusinessContext.Provider value={business}>{children}</BusinessContext.Provider>;
}

export function useBusiness(): BusinessInfo {
  return useContext(BusinessContext);
}
